import {definePreset} from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

export const AppThemePreset = definePreset(Aura, {
    semantic: {
        green: {
            50: '#ecfdf5', 100: '#d1fae5', 200: '#a7f3d0', 300: '#6ee7b7',
            400: '#34d399', 500: '#10b981', 600: '#059669', 700: '#047857',
            800: '#065f46', 900: '#064e3b', 950: '#022c22'
        },
        red: {
            50: '#fef2f2', 100: '#fee2e2', 200: '#fecaca', 300: '#fca5a5',
            400: '#f87171', 500: '#ed5d5d', 600: '#e33232', 700: '#cc2828',
            800: '#991b1b', 900: '#7f1d1d', 950: '#450a0a'
        },
        primary: {
            50: "#eff6ff",
            100: "#dbeafe",
            200: "#bfdbfe",
            300: "#93c5fd",
            400: "#5096ef",
            500: "#3b82f6",
            600: "#2563eb",
            700: "#1d4ed8",
            800: "#1e40af",
            900: "#1e3a8a",
            950: "#172554"
        },
        colorScheme: {
            light: {
                primary: {
                    color: '{primary.400}',
                    contrastColor: '#ffffff',
                    hoverColor: '{primary.500}',
                    activeColor: '{primary.600}'
                },
                // #ed5d5d red
                highlight: {
                    background: '{primary.50}',
                    focusBackground: '{primary.100}',
                    color: '{primary.500}',
                    focusColor: '{primary.600}'
                }
            },
            dark: {
                primary: {
                    color: '{primary.400}',
                    contrastColor: '{surface.900}',
                    hoverColor: '{primary.300}',
                    activeColor: '{primary.200}'
                },
                highlight: {
                    background: 'color-mix(in srgb, {primary.400}, transparent 84%)',
                    focusBackground: 'color-mix(in srgb, {primary.400}, transparent 76%)',
                    color: 'rgba(255,255,255,.87)',
                    focusColor: 'rgba(255,255,255,.87)'
                }
            }
        }
    },
    components: {
        dialog: {
            css: ({dt}) => `
            .p-dialog {
                transform: none !important;

                .p-dialog-header {
                    border-bottom: 1px solid ${dt('dialog.border.color')};
                    border-radius: ${dt('dialog.border.radius')} ${dt('dialog.border.radius')} 0 0;
                    background-color: var(--p-surface-100);
                }

                .p-dialog-content {
                    padding-top: calc(var(--spacing) * 5);
                }

                .p-dialog-footer {
                    border-top: 1px solid ${dt('dialog.border.color')};
                }
            }
            `
        },
        datatable: {
            css: () => `
            .p-datatable {
                .p-datatable-header {
                    border-radius: 12px 12px 0 0;
                    overflow: hidden;
                }

                .p-paginator {
                    border-radius: 0 0 12px 12px;
                }
            }

            .p-datatable-r {
                .p-datatable-thead > tr > th:first-child {
                    border-top-left-radius: 12px;
                }
                .p-datatable-thead > tr > th:last-child {
                    border-top-right-radius: 12px;
                }
            }
            `
        }
    }
});
